import { FC } from 'react';
import { MetaData } from '@edikk-edikk/country-frontend';
import { useAdvertListContext } from '#advertList/hooks';

const AdvertListMetaData: FC = () => {
  const { seo } = useAdvertListContext();

  return <MetaData seo={seo} />;
};

export { AdvertListMetaData };
